<template>
  <div>
<L1 class="clockinouttable">
  <template slot="slot_title">
    <button class="pre month" @click="month=moment(month).add(-1, 'month').toISOString()"/>
    <div class="title">{{y}}年{{m+1}}月</div>
    <button class="next month" @click="month=moment(month).add(1, 'month').toISOString()"/>
    <span :style="{lineHeight: '40px', color: 'var(--color-border)', marginTop: '20px'}">補打卡請再表格相對位置點兩下</span>
    <Btn :bg="'var(--color-checked)'" :text="'匯出EXCEL'" :icon="'excel1'" :iconSize="25" :style="{marginLeft: 'auto'}" @click="toExcel"/>
  </template>
<table :style="{overflowY: 'auto'}" ref="toExcel">
  <thead>
    <tr>
      <td :style="{backgroundColor: 'var(--color-checked)', color: '#FFFFFF'}" class="br">員工</td>
      <td class="br" colspan="3" v-for="(user, u) in users" :key="`u-${u}`">{{user.name}}</td>
    </tr>
    <tr>
      <td :style="{backgroundColor: 'var(--color-pri)', color: '#FFFFFF'}" class="br">日期</td>
      <template v-for="(user, u) in users">
      <td :key="`u-${u}-up`">上班</td>
      <td :key="`u-${u}-out`">下班</td>
      <td class="br"  :key="`u-${u}-delta`">上班時數</td>
      </template>
    </tr>
  </thead>
  <tbody>
    <EachDate v-for="d in dateLen" :key="d" :id="moment().startOf('month').set('year', y).set('month', m).set('date', d).format('yyyy-MM-DD')"
    :date="moment().startOf('month').set('year', y).set('month', m).set('date', d)"
    :items="data"
    :users="users"
    @makeup="change={ ...$event, value: null }">
    </EachDate>
  </tbody>
  <tfoot>
    <tr>
      <th class="br">總計時數</th>
      <td class="br" v-for="(user, u) in users" :key="`foot-${u}`" colspan="3">{{getusertotal(user)}}</td>
    </tr>
    <tr>
      <th class="br">出勤日數</th>
      <td class="br" v-for="(user, u) in users" :key="`foot-${u}`" colspan="3">{{getuserdaytotal(user)}} 日</td>
    </tr>
    <tr>
      <th class="br">時薪</th>
      <td class="br" v-for="(user, u) in users" :key="`foot-${u}`" colspan="3">
        <input type="text" v-model.number="user.fee">
      </td>
    </tr>
    <tr>
      <th class="br">薪資</th>
      <td class="br" v-for="(user, u) in users" :key="`foot-${u}`" colspan="3">{{getusertotalhour(user)}} 元</td>
    </tr>
  </tfoot>
</table>
</L1>
<Dialog @close="change=null" v-if="change" :show="!!change" :label="`補打卡-${change.user.name}`" :width="'500px'">
  <div :style="{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    padding: '25px 20px 20px 20px'
  }">
    <Select :width="'292px'" :defaultValue="change.type" @input="change.type=$event" :align="'center'">
      <option value="Up">上班</option>
      <option value="Out">下班</option>
    </Select>
    <DateInput :defaultValue="change.date" @input="change.date=$event" :width="'292px'"/>
    <input type="time" v-model="change.value">
    <!-- <TimeInput :min="1" :defaultValue="change.value" @input="change.value=$event" :width="'292px'"/> -->
    <Btns :style="{marginTop: '10px'}" @cancel="change=null" @save="save"/>
  </div>
</Dialog>
  </div>
</template>

<script>
import Btns from '../../components/btn/btns.vue'
import Select from '../../components/select.vue'
// import TimeInput from '../../components/input/time.vue'
import DateInput from '../../components/input/date.vue'
import Dialog from '../../components/dialognoPadding2.vue'
import Btn from '../../components/btn/sqr40016.vue'
import L1 from '../../components/layout/L1.vue'
import EachDate from './eachdate.vue'
import { get } from '../../store/fetch'
import * as XLSX from 'xlsx'
export default {
  methods: {
    toExcel () {
      const wb = XLSX.utils.table_to_book(this.$refs.toExcel, { sheet: `${this.moment(this.month).format('yyyy年MM月')}` })
      XLSX.writeFile(wb, `出勤紀錄_${this.moment(this.month).format('yyyy年MM月')}.xlsx`)
    },
    getuserdaytotal (user) {
      const hour = [].concat(...this.data.map(e => e.emps)).filter(e => e._id === user._id).map(e => e.delta ? e.delta : 0).length
      return hour
      // return user
    },
    getusertotal (user) {
      const hour = [].concat(...this.data.map(e => e.emps)).filter(e => e._id === user._id).map(e => e.delta ? e.delta : 0).reduce((a, b) => a + b, 0)
      return `${parseInt(hour / 60)} 小時 ${parseInt(hour % 60)} 分鐘`
      // return user
    },
    getusertotalhour (user) {
      const hour = [].concat(...this.data.map(e => e.emps)).filter(e => e._id === user._id).map(e => e.delta ? e.delta : 0).reduce((a, b) => a + b, 0)
      return (user.fee * parseInt((hour / 60).toFixed(2) * 100) / 100).toFixed(1)
      // return user
    },
    async save () {
      console.log(this.change, this.change.user._id)
      if (this.change.user._id) {
        const r = await this.$store.dispatch('save', {
          url: `webapi/clockinout/cover/${this.change.user._id}`,
          body: {
            type: this.change.type,
            date: this.moment(this.change.date).startOf('day').toISOString(),
            value: this.moment(`${this.change.date} ${this.change.value}`).toISOString()
          }
        })
        if (r) {
          this.getdata()
          this.change = null
        }
      }
    },
    async getdata () {
      const dates = await get(`webapi/clockinout/month?y=${this.y}&m=${this.m + 1}`)
      this.data = dates
    }
  },
  components: {
    EachDate,
    L1,
    Btn,
    Dialog,
    DateInput,
    // TimeInput,
    Select,
    Btns
  },
  watch: {
    y () {
      this.getdata()
    },
    m () {
      this.getdata()
    }
  },
  data () {
    return {
      change: null,
      month: this.moment().toISOString(),
      data: [],
      users: []
    }
  },
  computed: {
    m () {
      return this.moment(this.month).month()
    },
    y () {
      return this.moment(this.month).year()
    },
    dateLen () {
      return this.moment(this.month).endOf('month').date()
    }
  },
  async mounted () {
    this.getdata()
    const users = await get(`webapi/users/clockinout?date=${this.moment().startOf('date').toISOString()}`)
    this.users = users.map(e => {
      return {
        ...e,
        fee: 0
      }
    })
  }
}
</script>

<style lang="scss">
.clockinouttable {
  table {
    display: table;
    tr {
      height: 30px;
      display: table-row;
    }
    thead {
      display: table-header-group;
    }
    tbody {
      display: table-row-group;
      tr {
        &:hover {
          background-color: var(--color-checked);
          color: #FFFFFF;
        }
      }
    }
    tfoot {
      display: table-footer-group;
    }
  }
  #setDate-input {
    border: 1px solid #C4C4C4;
  }
  table {
    border-collapse: collapse;
  }
  tr {
    .br {
      border-right: 1px solid  var(--color-checked);
    }
    &:nth-child(odd) {
      background-color: var(--color-infobox);
    }
  }
  thead {
    tr {
      border-bottom: 1px solid var(--color-checked);
    }
    th, td {
      height: 35px;
    }
  }
  tbody {
    th, td {
      height: 21px;
    }
    tr:last-child {
      border-bottom: 1px solid var(--color-checked);
    }
  }
  tfoot {
    th, td {
      height: 35px;
      border-bottom: 1px solid var(--color-checked);
    }
  }
}
</style>
<style lang="scss" scoped>
input[type=text] {
  width: 50%;
  text-align: center;
  border: none;
}
input[type=time] {
  border: 1px solid #C4C4C4;
  height: 40px;
  width: 292px;
  font-size: 20px;
  color: #676767;
  letter-spacing: .1em;
  padding-left: 10px;
  padding-right: 5px;
  &::-webkit-calendar-picker-indicator {
    background-color: var(--color-pri);
    mask-image: url(/svg/icon/clock.svg);
    background-image: none;
    mask-size: 23px;
    mask-position: center;
    mask-repeat: no-repeat;
  }
}
.title {
  color: var(--color-pri);
  letter-spacing: .1em;
  font-size: 24px;
  height: 40px;
}
.month {
  width: 40px;
  height: 40px;
  mask-image: url(/svg/btn/arrowLeft.svg);
  background-color: var(--color-checked);
  mask-repeat: no-repeat;
  mask-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &.next {
    transform: rotate(180deg);
  }
}
</style>
